import { useCallback, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FJMediaSetting from './FJMediaSetting';
import {
    setSliceMediaSource,
    setSliceRatio,
    setSliceStockType,
    setSliceTextToImageStyle,
} from '../../../redux/slices/FJSliceTextToVideo';
import useLocalStore from '../../../hooks/useLocalStore';
import FJAppConstant from '../../../constants/FJAppConstant';
import PropTypes from 'prop-types';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import FJConstant from '../../../constants/FJConstant';
const FJMediaSettingContainer = ({ isShowCreditIcon }) => {
    useLocalStore();
    const dispatch = useDispatch();
    const textToImageStyle = useSelector(state => state.textToVideo.textToImageStyle);
    const textToImageStyleList = useSelector(state => state.textToVideo.textToImageStyleList);
    const ratio = useSelector(state => state.textToVideo.ratio);
    const mediaSource = useSelector(state => state.textToVideo.mediaSource);
    const stockType = useSelector(state => state.textToVideo.stockType);
    const selectTab = useSelector(state => state.textToVideo.selectTab);
    const textToVideoStep = useSelector(state => state.textToVideo.textToVideoStep);

    useEffect(() => {
        if (textToVideoStep === FJConstant.STEP_TYPE_VIDEO_SETTINGS) {
            dispatch(FJActionTextToVideo.initMediaSourceAction());
        }
    }, [dispatch, textToVideoStep]);
    const onChangeStyle = useCallback(
        style => {
            dispatch(setSliceTextToImageStyle(style));
        },
        [dispatch],
    );
    const onChangeRatio = useCallback(
        ratio => {
            dispatch(setSliceRatio(ratio));
        },
        [dispatch],
    );
    const onChangeMediaSource = useCallback(
        mediaSource => {
            dispatch(setSliceMediaSource(mediaSource));
        },
        [dispatch],
    );
    const onChangeStockType = useCallback(
        stockType => {
            dispatch(setSliceStockType(stockType));
        },
        [dispatch],
    );
    const isOnlyShowRatio = useMemo(() => {
        return selectTab !== FJAppConstant.PRODUCT_URL_TO_VIDEO;
    }, [selectTab]);

    return (
        <FJMediaSetting
            textToImageStyle={textToImageStyle}
            textToImageStyleList={textToImageStyleList}
            onChangeStyle={onChangeStyle}
            ratio={ratio}
            mediaSource={mediaSource}
            onChangeRatio={onChangeRatio}
            onChangeMediaSource={onChangeMediaSource}
            stockType={stockType}
            onChangeStockType={onChangeStockType}
            isOnlyShowRatio={isOnlyShowRatio}
            isShowCreditIcon={isShowCreditIcon}
        />
    );
};

FJMediaSettingContainer.propTypes = {
    isShowCreditIcon: PropTypes.bool,
};

export default FJMediaSettingContainer;
